import { get } from 'lodash';
import { OutageStrategyEnum, ProjectConfigInterface } from 'src/interfaces';

export const generateOutageStrategyOptions = () => {
  const options = Object.entries(OutageStrategyEnum).map(([label, value]) => ({
    label: label,
    value: value,
  }));

  return options;
};

export const generateProjectConfigAssets = (
  projectConfigKey: keyof ProjectConfigInterface,
  value: unknown,
) => {
  switch (projectConfigKey) {
    case 'customizedOutageConfig': {
      const url = get(value, 'stamp.url', '') as string;

      return url ? [url] : null;
    }

    default:
      return null;
  }
};
